<template>
  <div>
    <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 40}" v-model="msg" maxlength="200" placeholder="请输入1000字以内的小助手通知消息"/>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">发送通知</el-button>
    </div>
  </div>
</template>

<script>
import { sendSystemMessage } from "@/api/url";
import { postFormData } from "@/api/api";

export default {
  name: "SendSystemMessage",
  props: {
    value: Object
  },
  data() {
    return {
      userIdArray: this.value.userIdArray,
      msg: this.value.default?this.value.default:'',
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    unique(arr) {
      if (!Array.isArray(arr)) {
        console.log('type error!')
        return
      }
      let res = []
      for (let i = 0; i < arr.length; i++) {
        if (res.indexOf(arr[i]) === -1) {
          res.push(arr[i])
        }
      }
      return res
    },

    submit() {
      if ( !this.msg ) {
        this.$message({
          message: '通知内容不能为空',
          duration: 2000,
          type: 'warning'
        })
        return  false
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.unique(this.userIdArray)
      param['content'] = this.msg
      postFormData(sendSystemMessage, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }

}
</script>

<style scoped>

</style>
